import * as crypto from 'crypto';

export const decrytData = (message) => {
    const decipher = crypto.createDecipheriv(
      "aes-128-cbc",
      Buffer.from(String(process.env.NEXT_PUBLIC_STASHWISE_ENCRYPTIONKEY)).subarray(0, 16),
      Buffer.from(process.env.NEXT_PUBLIC_STASHWISE_ENCRYPTIONIV, "hex")
    );
    let decryptedMessage = decipher.update(Buffer.from(message, "hex"));
    decryptedMessage = Buffer.concat([decryptedMessage, decipher.final()]);
    return decryptedMessage.toString();
};
  
export const encryptData = (message) => {
    let result;
    try {
      const cipher = crypto.createCipheriv(
        "aes-128-cbc",
        Buffer.from(String(process.env.NEXT_PUBLIC_STASHWISE_ENCRYPTIONKEY)).subarray(0, 16),
        Buffer.from(process.env.NEXT_PUBLIC_STASHWISE_ENCRYPTIONIV, "hex")
      );
      let encryptedMessage = cipher.update(message);
      encryptedMessage = Buffer.concat([encryptedMessage, cipher.final()]);
      result = encryptedMessage.toString("hex");
    } catch (error) {
      result = "";
    }
    return result;
};